import { Accordion } from "@app/shared/Accordion"
import { JSX } from "react";

interface ProfileInformationPanelProps<TItemType> {
  title: string;
  dataName: string;
  dataValue: string;
  items: TItemType[];
  renderItem: (item: TItemType, index: number) => React.ReactNode;
}

export default function ProfileInformationPanel<TItemType,>({ title, dataName, dataValue, items, renderItem }: ProfileInformationPanelProps<TItemType>): JSX.Element {
  return (
    <Accordion title={title} testId="profile__information-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-title">{dataName}</dt>
          <dd className="provider-profile__overview-title">{dataValue}</dd>
        </div>

        {items.map((item, index) =>
        <div key={index} className="provider-profile__overview-row">
          {renderItem(item, index)}
        </div>
        )}
      </dl>
    </Accordion>
  )
}